import { render, staticRenderFns } from "./FpuiPackageDetail.vue?vue&type=template&id=e07e7c74&lang=pug&"
import script from "./FpuiPackageDetail.vue?vue&type=script&lang=js&"
export * from "./FpuiPackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./FpuiPackageDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports